import script from "./Submissions.vue?vue&type=script&setup=true&lang=js"
export * from "./Submissions.vue?vue&type=script&setup=true&lang=js"

import "./Submissions.vue?vue&type=style&index=0&id=394aa8ba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-394aa8ba"]])

export default __exports__